import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { FeedbackService } from '@app/core/services/feedback.service';
import { UserListService } from './services/user-list-service';
import { UserListParamsModel } from './user-list-params.model';
import { UserListComponent } from './user-list.component';
import { UserListModel } from './user-list.model';

@Component({
	selector: 'fm-user-list-control',
	templateUrl: './user-list-control.component.html',
	styleUrls: ['./user-list-control.component.less'],
	standalone: true,
	imports: [MatButtonModule],
})
export class UserListControlComponent {
	@Input() accountId: number;

	constructor(
		private readonly matDialog: MatDialog,
		private readonly userListService: UserListService,
		private readonly feedbackService: FeedbackService
	) {}

	openUserDialog(): void {
		const dialogConfig: Partial<MatDialogConfig> = {};
		dialogConfig.disableClose = true;
		dialogConfig.maxHeight = '650px';
		dialogConfig.width = '500px';
		dialogConfig.data = { Account: this.accountId } as UserListParamsModel;

		const dialogRef = this.matDialog.open(UserListComponent, dialogConfig);
		dialogRef.afterClosed().subscribe((result) => {
			if (result === undefined) {
				return;
			}

			this.assignAccount(result);
		});
	}

	assignAccount(result: UserListModel[]): void {
		const users = result.map(
			(user) =>
				({
					Id: user.Id,
					Selected: user.Selected,
				} as UserListModel)
		);

		const isPlural = users.length > 1;

		this.userListService.assignAccount(this.accountId, users).subscribe(() => {
			this.feedbackService.success('updated', isPlural ? 'Users' : 'User', { isPlural });
		});
	}
}
